import React from 'react';

const PayoutBetShop = ({ t }) => {
  return (
    <div className='roulette-betshop-table'>
      <div className='roulette-betshop-table-head'>
        <p className='roulette-betshop-table-title'>{t('BET')}</p>
        <p className='roulette-betshop-table-title'>{t('PAYOUT')}</p>
      </div>
      <dl className='roulette-betshop-table-description'>
        <div className='roulette-betshop-table-row'>
          <dt className='roulette-betshop-table-desc-title'>{t('STRAIGHT_UP')}</dt>
          <dd className='roulette-betshop-table-desc-data'>x36</dd>
        </div>
        <div className='roulette-betshop-table-row'>
          <dt className='roulette-betshop-table-desc-title'>{t('SPLIT')}</dt>
          <dd className='roulette-betshop-table-desc-data'>x18</dd>
        </div>
        <div className='roulette-betshop-table-row'>
          <dt className='roulette-betshop-table-desc-title'>{t('STREET')}</dt>
          <dd className='roulette-betshop-table-desc-data'>x12</dd>
        </div>
        <div className='roulette-betshop-table-row'>
          <dt className='roulette-betshop-table-desc-title'>{t('CORNER')}</dt>
          <dd className='roulette-betshop-table-desc-data'>x9</dd>
        </div>
        <div className='roulette-betshop-table-row'>
          <dt className='roulette-betshop-table-desc-title'>{t('DOZENS')}</dt>
          <dd className='roulette-betshop-table-desc-data'>x3</dd>
        </div>
        <div className='roulette-betshop-table-row'>
          <dt className='roulette-betshop-table-desc-title'>{t('RED')} / {t('BLACK')}</dt>
          <dd className='roulette-betshop-table-desc-data'>x2</dd>
        </div>
        <div className='roulette-betshop-table-row'>
          <dt className='roulette-betshop-table-desc-title'>{t('EVEN')} / {t('ODD')}</dt>
          <dd className='roulette-betshop-table-desc-data'>x2</dd>
        </div>
        <div className='roulette-betshop-table-row'>
          <dt className='roulette-betshop-table-desc-title'>1-18 / 19-36</dt>
          <dd className='roulette-betshop-table-desc-data'>x2</dd>
        </div>
      </dl>
    </div>
  );
};
export default PayoutBetShop;
